<div class="col-12 col-md-12 mt-2">
  <div class="menu-options">
    <div class="main-title">
      <i class="fa fa-globe"></i>
      <span> {{"Browsers" | translate}}</span>
      <a class="pull-right btn btn-sm">
        <i class="fa fa-question-circle fa-fw" title="Admin can configure browsers here"></i>
      </a>
    </div>
    <div class="row mt-5" style="width: 100%;">
      <div class="col-7 col-md-7">
        <app-pagination [totalItems]="browsers.length" [itemsPerPage]="browserPageSize" [itemsSearch]="search"
          (searchedData)="onSearch($event)" (itemPerPageData)="onItemPerPageChange($event)"
          (nextPageChange)="onNextPageChange($event)">
        </app-pagination>
      </div>

      <div class="col-5 col-md-5">
        <button class="btn btn-success add-browser" (click)="openBrowserForm()" title="Add new browser"><span
        class="fa fa-plus"></span>&nbsp; {{"Add Browser" | translate}}</button>
        <button class="btn btn-danger remove"
          (click)="removeBrowsers(search, filteredBrowsers, confirmRemove.value, delete_all_browsers)"
          title="Remove all browsers"><span class="fa fa-regular fa-trash-o"></span>&nbsp; {{"Remove All" |
        translate}}</button>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-12 browser-table">
    @for (browser of browsers | paginate: { itemsPerPage: browserPageSize, currentPage: page } | search: search; track browser; let i = $index) {
      <li class="list-group-item"
        >
        <hr>
          <div class="browser-line browser-actions d-flex">
            <i class="fa fa-globe fa-2x fa-fw browser-list-icon"></i>
            <div class="browser-list-details selectable">
              <div class="browser-list-name">{{ browser.browser | titlecase }} {{ browser.browserVersion }}</div>
              <div class="browser-list-id">
                <span>{{"ID" | translate}}</span>
                <span>{{ ':: ' + browser.id + ' - ' }}</span>
                <span>{{"OS" | translate}}</span>
                <span>{{ ': ' + (browser.os | titlecase) + ' - ' }}</span>
                <span>{{"IP" | translate}}</span>
                <span>{{ ': ' + browser.ip }}</span>
                <br>
                  <span>{{"Port" | translate}}</span>
                  <span>{{ ': ' + browser.port + ' - ' }}</span>
                  <span>{{"Automation Port" | translate}}</span>
                  <span>{{ ': ' + browser.automationPort + ' - ' }}</span>
                  <span>{{"Username" | translate}}</span>
                  <span>{{ ': ' + browser.username }}</span>
                </div>
                <div class="browser-actions-buttons">
                  <button class="btn btn-outline-info view pull-right" type="button"
                    (click)="viewBrowser(browser)" title="View browser details">
                    <i class="fa fa-eye"></i>
                    <span>&nbsp; {{"View" | translate}}</span>
                  </button>
                  <button class="btn btn-outline-primary edit pull-right" type="button"
                    (click)="editBrowser(browser)" title="Edit browser">
                    <i class="fa fa-edit"></i>
                    <span>&nbsp; {{"Edit" | translate}}</span>
                  </button>
                  <button class="btn btn-outline-danger remove pull-right" type="button"
                    (click)="remove(browser.id, delete_browsers)" title="Delete browser">
                    <i class="fa fa-trash-o"></i>
                    <span>&nbsp; {{"Remove" | translate}}</span>
                  </button>
                </div>
              </div>
            </div>
          </li>
        }
      </div>
    </div>

    <!-- Browser Form Modal -->
    <div class="modal fade" id="browserFormModal" tabindex="-1" role="dialog" aria-labelledby="browserFormModalLabel"
      aria-hidden="true" [class.show]="showBrowserForm" [style.display]="showBrowserForm ? 'block' : 'none'">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="browserFormModalLabel">
              {{ isEditMode ? ('Edit Browser' | translate) : ('Add Browser' | translate) }}
            </h5>
            <button type="button" class="close" (click)="closeBrowserForm()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form #browserForm="ngForm" (ngSubmit)="saveBrowser()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="browserId">{{"ID" | translate}} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="browserId" name="id"
                      [(ngModel)]="currentBrowser.id" required [readonly]="isEditMode || isViewMode"
                      autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="browserType">{{"Browser" | translate}} <span
                    class="text-danger">*</span></label>
                    <select class="form-control" id="browserType" name="browser"
                      [(ngModel)]="currentBrowser.browser" required [disabled]="isViewMode">
                      <option value="">Select Browser</option>
                      <option value="chrome">Chrome</option>
                      <option value="firefox">Firefox</option>
                      <option value="edge">Edge</option>
                      <option value="safari">Safari</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="browserVersion">{{"Browser Version" | translate}} <span
                    class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="browserVersion" name="browserVersion"
                      [(ngModel)]="currentBrowser.browserVersion" required [readonly]="isViewMode"
                      autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="os">{{"Operating System" | translate}} <span
                    class="text-danger">*</span></label>
                    <select class="form-control" id="os" name="os" [(ngModel)]="currentBrowser.os" required
                      [disabled]="isViewMode">
                      <option value="">Select OS</option>
                      <option value="windows">Windows</option>
                      <option value="linux">Linux</option>
                      <option value="macos">macOS</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="ip">{{"IP Address" | translate}} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="ip" name="ip"
                      [(ngModel)]="currentBrowser.ip" required pattern="^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$"
                      [readonly]="isViewMode" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="port">{{"Port" | translate}} <span class="text-danger">*</span></label>
                    <input type="number" class="form-control" id="port" name="port"
                      [(ngModel)]="currentBrowser.port" required min="1" max="65535"
                      [readonly]="isViewMode" autocomplete="off">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="automationPort">{{"Automation Port" | translate}} <span
                    class="text-danger">*</span></label>
                    <input type="number" class="form-control" id="automationPort" name="automationPort"
                      [(ngModel)]="currentBrowser.automationPort" required min="1" max="65535"
                      [readonly]="isViewMode" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="username">{{"Username" | translate}} <span
                    class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="username" name="username"
                      [(ngModel)]="currentBrowser.username" required [readonly]="isViewMode"
                      autocomplete="off">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="password">{{"Password" | translate}} <span
                    class="text-danger">*</span></label>
                    <input type="password" class="form-control" id="password" name="password"
                      [(ngModel)]="currentBrowser.password" required [readonly]="isViewMode"
                      autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="accessUrl">{{"Access URL" | translate}}</label>
                    <input type="url" class="form-control" id="accessUrl" name="accessUrl"
                      [(ngModel)]="currentBrowser.accessUrl" [readonly]="isViewMode" autocomplete="off">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="automationUrl">{{"Automation URL" | translate}}</label>
                    <input type="url" class="form-control" id="automationUrl" name="automationUrl"
                      [(ngModel)]="currentBrowser.automationUrl" [readonly]="isViewMode">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="ngasaUrl">{{"NGASA URL" | translate}}</label>
                    <input type="url" class="form-control" id="ngasaUrl" name="ngasaUrl"
                      [(ngModel)]="currentBrowser.ngasa_url" [readonly]="isViewMode">
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeBrowserForm()">
              {{"Cancel" | translate}}
            </button>
            @if (!isViewMode) {
              <button type="button" class="btn btn-primary" (click)="saveBrowser()"
                [disabled]="!browserForm?.valid">
                {{ isEditMode ? ('Update' | translate) : ('Save' | translate) }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Templates -->
    <ng-template #alert_message let-modal>
      <div class="modal-body text-center">
        <p class="alert-message" style="overflow-wrap: break-word;">{{alertMessage | translate}}</p>
        <div class="alert-actions">
          <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
        </div>
      </div>
    </ng-template>

    <ng-template #delete_all_browsers let-modal>
      <div class="modal-body text-center">
        <p class="alert-message">{{"Are you sure you want to delete all browsers?" | translate}}</p>
        <div class="alert-actions">
          <button type="button" class="btn btn-success" (click)="removeBrowsers();">{{"Yes, Proceed" |
          translate}}</button>&nbsp;
          <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
          translate}}</button>&nbsp;
        </div>
      </div>
    </ng-template>

    <ng-template #delete_browsers let-modal>
      <div class="modal-body text-center">
        <p class="alert-message">{{"Are you sure you want to delete this browser?" | translate}}</p>
        <div class="alert-actions">
          <button type="button" class="btn btn-success" (click)="removeBrowser();">{{"Yes, Proceed" |
          translate}}</button>&nbsp;
          <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
          translate}}</button>&nbsp;
        </div>
      </div>
    </ng-template>